import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input('backgroundGray') public backgroundGray;
  contactForm: FormGroup;
  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      message: ['', Validators.required]
    })
  }

  onSubmit() {
  console.log( 'name='+this.contactForm.value.name+'&email='+this.contactForm.value.email+'&message='+this.contactForm.value.message );
	var newName = 'John Smith',
	xhr = new XMLHttpRequest();

	xhr.open('POST', 'assets/php/sm.php');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.onload = function() {
		if (xhr.status === 200 ) {
			console.log( 200, xhr.responseText );
			if ( xhr.responseText === 'done' ){
				document.getElementById( 'sendDone'  ).innerHTML = 'Сообщение отправлено. Мы скоро с Вами свяжемся';
				document.getElementById( 'sendError' ).innerHTML = '';
			} else {
				document.getElementById( 'sendDone'  ).innerHTML = '';
				document.getElementById( 'sendError' ).innerHTML = 'Не удалось отправить сообщение';
			}
		} else
		if ( xhr.status !== 200 ) {
			console.log( xhr.status, '!' );
			document.getElementById( 'sendDone'  ).innerHTML = '';
			document.getElementById( 'sendError' ).innerHTML = 'Не удалось отправить сообщение';
		}
	};
	xhr.send(encodeURI('name='+this.contactForm.value.name+'&email='+this.contactForm.value.email+'&message='+this.contactForm.value.message));
  }
}
